'use client';

export { default } from './Link';
export * from './linkClasses';
export { default as linkClasses } from './linkClasses';
export * from './LinkProps';